var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"minh"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }